import { supabase } from "@/integrations/supabase/client";

export type AutomationEvent = 
  | 'quote_created'
  | 'quote_paid'
  | 'reservation_created'
  | 'reservation_confirmed'
  | 'payment_received'
  | 'contract_signed'
  | 'checkin_completed'
  | 'task_day';

export interface ScheduleAutomationParams {
  event: AutomationEvent;
  targetType: 'quote' | 'reservation' | 'client';
  targetId: string;
}

/**
 * Schedule automations for a given event
 * This will trigger any active automations that match the event
 */
export const scheduleAutomation = async (params: ScheduleAutomationParams): Promise<void> => {
  try {
    console.log('Scheduling automation for event:', params.event, 'target:', params.targetType, params.targetId);
    
    const { error } = await supabase.functions.invoke('execute-automations', {
      body: {
        action: 'schedule',
        event: params.event,
        targetType: params.targetType,
        targetId: params.targetId,
      }
    });

    if (error) {
      console.error('Error scheduling automation:', error);
      // Don't throw - automations are non-blocking
    } else {
      console.log('Automation scheduled successfully for event:', params.event);
    }
  } catch (error) {
    console.error('Error scheduling automation:', error);
    // Don't throw - automations should never block main operations
  }
};
